<template>
  <div
    v-if="auctionsCatalog.auctionHouse"
    class="row tab-content-details pt-0 no-gutters">
    <div class="col-12 col-sm-6 left-column">
      <p><strong>{{ auctionsCatalog.auctionHouse.name }}</strong></p>
      <FullAddress
        :address="auctionsCatalog.address || auctionsCatalog.auctionHouse"
        :localizationFromLegacy="auctionsCatalog.auctionLocalizationFromLegacy"
      />
      <div
        v-if="auctionsCatalog.preAuctionExhibitionStart"
      >
        <p class="pre-auction">{{ I18n.t("pre_auction_exhibition") }}</p>
        <p><strong>{{ auctionsCatalog.preAuctionExhibitionStart, auctionsCatalog.preAuctionExhibitionEnd | exhibitionDate }}</strong></p>
        <FullAddress
          v-if="auctionsCatalog.exhibitionAddress"
          :address="auctionsCatalog.exhibitionAddress"
        />
      </div>
    </div>
    <div v-if="haveStatisticsProvided" class="col-12 col-sm-6 text-sm-right mt-3 mt-sm-0 right-column">
      <p>{{ I18n.t("auctions_catalogs.total_sales") }}</p>
      <p class="price price--highlight"><strong>{{ I18n.t("artworks.price", { price: formatPrice(auctionsCatalog.totalSalesWithCommission) }) }}</strong></p>
      <p>{{ I18n.t("employees.auctions_catalogs.payments.with_commission") }} </p>
      <p class="mt-3 mt-sm-5"> {{ I18n.t("auctions_catalogs.sold_positions") }}</p>
      <p class="sold-number"><strong> {{ auctionsCatalog.soldArtworksCount }}/{{ auctionsCatalog.artworksCount }}</strong></p>
    </div>
    <div
      v-if="auctionsCatalogIsUnpublished"
      class="col-6 text-md-right right-column"
    >
      <p>
        {{ I18n.t("auctions_catalogs.waiting_for_results") }}
      </p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FullAddress from '@/shared/components/full_address';
  import { formatNumber } from '@/shared/helpers';
  import { UNPUBLISHED_STATUS } from '../consts';

  export default {
    name: 'AuctionDetails',
    components: {
      FullAddress,
    },
    created() {
      this.formatPrice = formatNumber;
    },
    computed: {
      ...mapGetters([
        'auctionsCatalog',
        'auctions',
      ]),
      haveStatisticsProvided() {
        return Object.prototype.hasOwnProperty.call(this.auctionsCatalog, 'soldArtworksCount') ||
          Object.prototype.hasOwnProperty.call(this.auctionsCatalog, 'artworksCount') ||
          Object.prototype.hasOwnProperty.call(this.auctionsCatalog, 'totalSalesWithCommission');
      },
      auctionsCatalogIsUnpublished() {
        return this.auctionsCatalog.status === UNPUBLISHED_STATUS;
      },
    },
    filters: {
      exhibitionDate(start, end) {
        const startDate = new Date(start);
        const endDate = new Date(end);

        return `${startDate.getDate()}.${startDate.getMonth() + 1} - ${endDate.getDate()}.${endDate.getMonth() + 1}.${endDate.getFullYear()}`;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/auctions_catalogs/show/components/auction_details.vue?f612b032